import type { SelectOption } from '@chatsdet/ui';
import type { QaReportStatus } from '../qaStatus';

export type CanonicalPageDetailResponse = {
  canonicalPage: {
    id: string;
    propertyId: string;
    orgId: string;
    url: string;
    title: string | null;
    firstSeenAt: string;
    lastSeenAt: string;
    seenCount: number;
    latestScreenshotS3Key?: string | null;
    latestDescription?: string | null;
    latestPurpose?: string | null;
    latestKeyElements?: string[] | null;
    lastSeenCrawlId?: string | null;
    lastSeenCredentialId?: string | null;
    updatedAt?: string;
  };
  latestQaReport?: QaReportSummary | null;
  latestCrawlPageId?: string | null;
  latestCrawlPage?: {
    id: string;
    crawlId: string;
    screenshotS3Key: string | null;
    createdAt: string;
  } | null;
  hasPublicCrawl?: boolean;
  crawlCredentialIds?: string[];
  latestElements?: TaxonomyElement[] | null;
};

export type QaReportSummary = {
  id: string;
  status: QaReportStatus;
  summary?: string | null;
  hasIssues: boolean;
  issuesFoundCount: number;
  testedItems: string[];
  todoItems: Array<{
    id?: string | null;
    item: string;
    status: QaReportTodoStatus;
    summary?: string | null;
    elementId?: string | null;
    elementLabel?: string | null;
    elementType?: string | null;
    templateId?: string | null;
    templateName?: string | null;
  }>;
  actionsLog: Array<{ action: string; outcome?: string | null }>;
  credentialId?: string | null;
  diagnosticId?: string | null;
  jobId?: string | null;
  brokerJobId?: string | null;
  traceStorageKey?: string | null;
  details?: Record<string, unknown> | null;
  startedAt?: string | null;
  completedAt?: string | null;
};

export type QaReportTodoStatus = 'pending' | 'done' | 'healthy' | 'unhealthy' | 'not_applicable';

export type QaReportListResponse = {
  ok: boolean;
  reports: QaReportSummary[];
  pagination: {
    page: number;
    pageSize: number;
    totalItems: number;
    totalPages: number;
  };
};

export type TaxonomyElement = {
  id: string;
  type: TaxonomyElementType;
  label: string;
  description?: string | null;
  screenshotS3Key?: string | null;
  screenshotUrl?: string | null;
};

export type TaxonomyElementType =
  | 'data_table'
  | 'form'
  | 'table'
  | 'button'
  | 'link'
  | 'input'
  | 'other';

export const TAXONOMY_TYPE_OPTIONS: SelectOption[] = [
  { id: 'all', label: 'All types' },
  { id: 'data_table', label: 'Data table' },
  { id: 'form', label: 'Form' },
  { id: 'table', label: 'Table' },
  { id: 'button', label: 'Button' },
  { id: 'link', label: 'Link' },
  { id: 'input', label: 'Input' },
  { id: 'other', label: 'Other' },
];

export const TAXONOMY_LABELS: Record<TaxonomyElementType, string> = {
  data_table: 'Data table',
  form: 'Form',
  table: 'Table',
  button: 'Button',
  link: 'Link',
  input: 'Input',
  other: 'Other',
};
